import { Link } from "@inertiajs/react";
import ContactLink from "@/components/ContactLink";
import Steps, { Step } from "@/components/help/Steps";

export default function PayingForYourCampaign() {
  return (
    <>
      <p>
        Every school starts on a free trial. You can set up a campaign and see how PagePledge works before paying anything. To run the campaign, pay its flat fee and we'll approve it.
      </p>

      <h2>What the free trial includes</h2>
      <ul>
        <li>Creating campaigns and editing their dates, goals and description</li>
        <li>Importing classrooms and students</li>
        <li>Setting up school rewards and student prizes</li>
        <li>Printing take-home sheets (families can activate once the campaign is approved, so send them home after that)</li>
        <li>Adding other school admins (we don't email them an invitation on the trial; they sign in from the sign-in page)</li>
      </ul>

      <h2>What needs a paid campaign</h2>
      <ul>
        <li>Going live on your start date</li>
        <li>Taking donations, and public student donation pages</li>
        <li>Connecting Square</li>
        <li>Adding teachers</li>
        <li>Emails to teachers and families, including parent activation</li>
      </ul>
      <p>
        In the setup guide, the steps that need it (Square, teachers and launch) show a padlock and <strong>Locked until paid</strong>. If your start date arrives before the campaign is approved, it waits in draft and goes live once it's approved. If its end date passes too, move the dates before paying so it has time to run.
      </p>

      <h2>What it costs</h2>
      <p>
        One flat fee per campaign, based on how many students are in it, never a percentage of what you raise. Current prices are on the <a href="/pricing">pricing page</a>. The setup guide's <strong>Pay the campaign fee</strong> step (and the setup card on your dashboard) shows the price for the students you've added so far, so if you add more before paying, the price can move up a tier.
      </p>
      <p>
        Once it's paid, your campaign's plan covers up to its student limit. If you need more room later, contact us to upgrade.
      </p>

      <h2>How to pay</h2>
      <Steps>
        <Step title="Add your students">
          <p>If you can, import your classrooms first, so the price covers your whole campaign. Otherwise, choose the plan for the number of students you expect.</p>
        </Step>
        <Step title="Open the payment page">
          <p>Click <strong>Choose your plan and pay</strong> in the setup guide's <strong>Pay the campaign fee</strong> step, or <strong>How to pay</strong> on your dashboard. Your plan is picked for you from your student count; choose a bigger one if more students are coming.</p>
        </Step>
        <Step title="Send the e-Transfer">
          <p>Send an Interac e-Transfer for the total to <strong>payments@pagepledge.com</strong>, with your school and campaign name in the message. <ContactLink>Contact us</ContactLink> if you have questions.</p>
        </Step>
      </Steps>

      <h2>What happens next</h2>
      <p>
        When your payment arrives, we approve the campaign. The <strong>Free trial</strong> badge and the padlocks go away, and you can connect Square, invite teachers and launch. Each new campaign is paid for the same way: until it is, it's marked <strong>Awaiting payment</strong>. Square stays connected from your first campaign.
      </p>

      <h2>Related</h2>
      <ul>
        <li><Link href="/help/articles/fees-and-pricing">How fees and pricing work</Link></li>
        <li><Link href="/help/articles/creating-a-campaign">Creating your campaign</Link></li>
      </ul>
    </>
  );
}
